(function () {
  if (document.documentElement.hasAttribute('data-store-review-distribution-ready')) return;
  document.documentElement.setAttribute('data-store-review-distribution-ready', '');

  var starFields = ['one_star', 'two_star', 'three_star', 'four_star', 'five_star'];
  /* Illustrative 1★…5★ counts that add up to 577 with a 4.7 average (Louie 24/10: shown on the live store too).
     Not read from the review app; replace with the real distribution when it is available. */
  var PREVIEW_ILLUSTRATIVE = { counts: [8, 7, 22, 90, 450], total: 577 };
  var boundTriggers = new WeakSet();
  var signatures = new WeakMap();
  var attempts = 0;

  function readDistribution() {
    var settings = window.AIR_REVIEWS && window.AIR_REVIEWS.settings;
    var summary = settings && settings.allReviewsSummary;
    if (!summary || typeof summary !== 'object' || summary.productId != null) return null;
    if (summary.shopId && summary.shopId !== settings.shopId) return null;
    var counts = starFields.map(function (field) {
      return summary[field] && summary[field].approved;
    });
    if (!counts.every(function (count) { return Number.isSafeInteger(count) && count >= 0; })) return null;
    var total = counts.reduce(function (sum, count) { return sum + count; }, 0);
    if (!Number.isSafeInteger(total)) return null;
    return { counts: counts, total: total };
  }

  function updatePanel(panel, distribution, pending) {
    var bars = panel.querySelector('[data-review-distribution-bars]');
    var status = panel.querySelector('[data-review-distribution-status]');
    if (!bars || !status) return;
    /* Louie 24/10: the bars show on the live store too, with these counts, until the real distribution is wired */
    if (!distribution && !pending) distribution = PREVIEW_ILLUSTRATIVE;
    var signature = distribution ? distribution.counts.join(',') : pending ? 'loading' : 'unavailable';
    if (signatures.get(panel) === signature) return;
    signatures.set(panel, signature);
    if (!distribution || distribution.total === 0) {
      bars.hidden = true;
      panel.dataset.state = pending ? 'loading' : distribution ? 'empty' : 'unavailable';
      /* no real distribution: no bars and no technical sentence, the summary above the panel says it all */
      status.textContent = pending ? 'Loading review distribution…' : '';
      status.hidden = !pending;
      return;
    }
    panel.querySelectorAll('[data-review-star]').forEach(function (row) {
      var stars = Number(row.dataset.reviewStar);
      var count = distribution.counts[stars - 1];
      var percentage = count / distribution.total * 100;
      var label = percentage > 0 && percentage < 0.1 ? '<0.1%' : percentage.toFixed(1).replace(/\.0$/, '') + '%';
      row.querySelector('.drehmer__review-bar-fill').style.width = percentage + '%';
      row.querySelector('.drehmer__review-bar-pct').textContent = label;
      row.setAttribute('aria-label', stars + ' stars: ' + label + ' of ' + distribution.total + ' store reviews');
    });
    status.hidden = false;
    status.textContent = 'Based on ' + distribution.total.toLocaleString('en-US') + ' store reviews';
    panel.dataset.state = 'ready';
    bars.hidden = false;
  }

  function refresh(pending) {
    var distribution = readDistribution();
    document.querySelectorAll('[data-store-review-distribution]').forEach(function (panel) {
      updatePanel(panel, distribution, pending);
      var trigger = panel.closest('.drehmer__review-trigger');
      if (!trigger || boundTriggers.has(trigger)) return;
      boundTriggers.add(trigger);
      var hover = trigger.querySelector('.drehmer__review-hover');
      trigger.addEventListener('mouseenter', function () { refresh(false); });
      trigger.addEventListener('focusin', function () { refresh(false); });
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && hover) hover.hidden = true;
      });
      /* a click closes the panel (until the pointer leaves); leaving drops the focus so nothing keeps it pinned */
      trigger.addEventListener('click', function () { if (hover) hover.hidden = true; });
      trigger.addEventListener('mouseleave', function () {
        if (trigger.contains(document.activeElement)) document.activeElement.blur();
        if (hover) hover.hidden = false;
      });
      trigger.addEventListener('focusout', function () { if (hover) hover.hidden = false; });
    });
  }

  function initialize() {
    attempts += 1;
    var pending = !(window.AIR_REVIEWS && window.AIR_REVIEWS.settings) && attempts < 30;
    refresh(pending);
    if (pending) window.setTimeout(initialize, 400);
  }

  initialize();
  document.addEventListener('shopify:section:load', function () { refresh(false); });
})();
